var app = app || {};

app.nav = (function ($) {
	var $dropparents = $('li.nav__item--parent');
	var $primaryItems = $('.nav > li.nav__item');
	var $primaryLinks = $('.nav > li.nav__item > .nav__link'); 
	var $droplinks = $('.nav > li.nav__item--parent > .nav__link'); // Specifying the element is faster for older browsers
	headroomInit = function() {
	 	$(".header").headroom({
	        tolerance: {
	            down: 20,
	            up: 20
	        },
	        offset: 30,
	        classes: {
	            initial: "headroom",
	            pinned: "headroom--pinned",
	            unpinned: "headroom--unpinned",
	            top: "headroom--top",
	            notTop: "headroom--not-top"
	        }
	    });			
	},
	navToggle= function() {
		$("#nav-toggle").click(function() {
			//hide the secondary nav
			$(".header__secondary").toggleClass('header__secondary--active');
			//close any active tertiary nav
			$dropparents.removeClass('nav__item--active');
			$droplinks.removeClass('nav__link--back');
			//'deactivate' the button
			$(this).toggleClass('header__nav-toggle--active');
			document.addEventListener('click', navClickListener)
		});
	},
	navClickListener = function(event) {
	    var selector = $(".header");
	    // if the target of the click isn't the container nor a descendant of the container
	    if (!$(event.target).closest(selector).length) {
	      if ($(selector).is(':visible')) {
	        navClose();
	      }
	    }	
	}
	navClose = function() {
		$(".header__secondary").removeClass('header__secondary--active');
		//close any active tertiary nav
		$dropparents.removeClass('nav__item--active nav__item--hover');
		$droplinks.removeClass('nav__link--back');
		//'deactivate' the button
		$('.header__nav-toggle--active').removeClass('header__nav-toggle--active');
   
	}
	headroomHash = function() {
		// get the fixed menu out of the way if you're being directed to a page anchor.
	    if(window.location.hash) {
	      $(".header").addClass("headroom--unpinned");
	    }	
	},
	
	// dropdown menus on main navigation
	navDrop = function() {
		$droplinks.click(function(e) {
			var $item = $(this).parent(".nav__item--parent");
			// if it's already open, then close it
			if($item.hasClass('nav__item--active') || $item.hasClass('nav__item--hover')) {
				$item.removeClass('nav__item--active nav__item--hover');
				$(this).removeClass('nav__link--back');
			} else {
				// close any other navs that are currently open
				$dropparents.removeClass('nav__item--active');
				$item.addClass('nav__item--active');
				$(this).addClass('nav__link--back');
			}
			e.preventDefault();
		});
	},

	// optional - open menus on hover; only active on relo at present
	navHover = function() {
		$primaryLinks.hover(function() {
			// simple check just to check this isn't mobile.
			if(breakpoint.value != 'mobile' && breakpoint.value != 'mobileLandscape' && breakpoint.value !='tablet') {
				var $item = $(this).parent(".nav__item--parent");
				// close any other navs that are currently open
				$primaryItems.removeClass('nav__item--hover');
				$item.addClass('nav__item--hover');
			}
		});
	},

	clearDropdownsOnResize = function() {
        $(window).on("debouncedresize", function( event ) {
			$dropparents.removeClass('nav__item--hover nav__item--active');
        });
	}

	

    init = function () {
    	headroomInit();
    	navToggle();
    	navDrop();
    	headroomHash();
    	clearDropdownsOnResize();
		document.addEventListener('click', navClickListener)    	
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.nav.init);